import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const BrandVoice = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M4 12C4 9.23858 6.23858 7 9 7H23C25.7614 7 28 9.23858 28 12V24C28 26.7614 25.7614 29 23 29H9C6.23858 29 4 26.7614 4 24V12Z"
          fill="#BEE9FC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 8.4H9C7.01178 8.4 5.4 10.0118 5.4 12V24C5.4 25.9882 7.01177 27.6 9 27.6H23C24.9882 27.6 26.6 25.9882 26.6 24V12C26.6 10.0118 24.9882 8.4 23 8.4ZM9 7C6.23858 7 4 9.23858 4 12V24C4 26.7614 6.23858 29 9 29H23C25.7614 29 28 26.7614 28 24V12C28 9.23858 25.7614 7 23 7H9Z"
          fill="#2B2F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.6 10.0843C16.6 9.69768 16.2866 9.38428 15.9 9.38428C15.5134 9.38428 15.2 9.69768 15.2 10.0843V19.1904C15.2 19.577 15.5134 19.8904 15.9 19.8904C16.2866 19.8904 16.6 19.577 16.6 19.1904V10.0843ZM11.8 11.0961C11.8 10.7095 11.4866 10.3961 11.1 10.3961C10.7134 10.3961 10.4 10.7095 10.4 11.0961V18.1786C10.4 18.5652 10.7134 18.8786 11.1 18.8786C11.4866 18.8786 11.8 18.5652 11.8 18.1786V11.0961ZM14.2 12.6138C14.2 12.2272 13.8866 11.9138 13.5 11.9138C13.1134 11.9138 12.8 12.2272 12.8 12.6138V16.6609C12.8 17.0475 13.1134 17.3609 13.5 17.3609C13.8866 17.3609 14.2 17.0475 14.2 16.6609V12.6138ZM8.7 13.4314C9.0866 13.4314 9.4 13.7448 9.4 14.1314V15.1432C9.4 15.5298 9.0866 15.8432 8.7 15.8432C8.3134 15.8432 8 15.5298 8 15.1432V14.1314C8 13.7448 8.3134 13.4314 8.7 13.4314ZM23.1 13.4314C23.4866 13.4314 23.8 13.7448 23.8 14.1314V15.1432C23.8 15.5298 23.4866 15.8432 23.1 15.8432C22.7134 15.8432 22.4 15.5298 22.4 15.1432V14.1314C22.4 13.7448 22.7134 13.4314 23.1 13.4314ZM18.3 11.9138C18.6866 11.9138 19 12.2272 19 12.6138V16.6609C19 17.0475 18.6866 17.3609 18.3 17.3609C17.9134 17.3609 17.6 17.0475 17.6 16.6609V12.6138C17.6 12.2272 17.9134 11.9138 18.3 11.9138ZM20.7 10.3961C21.0866 10.3961 21.4 10.7095 21.4 11.0961V18.1786C21.4 18.5652 21.0866 18.8786 20.7 18.8786C20.3134 18.8786 20 18.5652 20 18.1786V11.0961C20 10.7095 20.3134 10.3961 20.7 10.3961Z"
          fill="#2B2F38"
        />
        <path
          d="M10.8 23.5C10.8 24.4941 9.99411 25.3 9 25.3C8.00589 25.3 7.2 24.4941 7.2 23.5C7.2 22.5059 8.00589 21.7 9 21.7C9.99411 21.7 10.8 22.5059 10.8 23.5Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M24.8 23.5C24.8 24.4941 23.9941 25.3 23 25.3C22.0059 25.3 21.2 24.4941 21.2 23.5C21.2 22.5059 22.0059 21.7 23 21.7C23.9941 21.7 24.8 22.5059 24.8 23.5Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path d="M16 7L24 4" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M13 23.5H19" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M16 7L8 4" stroke="#2B2F38" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    )
  },
)

export default BrandVoice
